/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bool, shape } from "prop-types";

import { selectors as transactionsSelectors } from "reducers/transactions";
import { withMultipleSignaturesContext } from "pages/transactions/MultipleSignaturesTables/MultipleSignaturesDataContext";
import * as i18n from "util/i18n";

import I18n from "pages/_components/I18n";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import CardContainer from "pages/_components/Card/CardContainer";
import Card from "pages/_components/Card/Card";

const getQuantityAndCurrency = (object) => {
    const amounts = object.transactionAmounts || {};
    const keys = Object.keys(amounts);
    if (keys.length > 0) {
        const currency = keys[0];
        return { currency, quantity: Number(amounts[currency]) || 0 };
    }
    const d = object.transaction?.data || {};
    if (d.amount != null && typeof d.amount !== "object") {
        return {
            currency: String(d.currency != null ? d.currency : "0"),
            quantity: Number(d.amount) || 0,
        };
    }
    if (d.amount && typeof d.amount === "object" && d.amount.quantity != null) {
        return {
            currency: String(d.amount.currency != null ? d.amount.currency : "0"),
            quantity: Number(d.amount.quantity) || 0,
        };
    }
    return { currency: "0", quantity: 0 };
};

class DirectDebitCreateSendDataTable extends Component {
    static propTypes = {
        isDesktop: bool.isRequired,
        multipleSignaturesData: shape({}).isRequired,
    };

    getActivityTitle = (idActivity, activityName) => {
        if (activityName && String(activityName).trim() !== "") {
            return activityName;
        }
        return i18n.get("activities.direct.debit.create.send", idActivity || "");
    };

    dataRow = () => {
        const { multipleSignaturesData, isDesktop } = this.props;
        const { selectedTransactionRows } = multipleSignaturesData;

        return selectedTransactionRows.map((object) => {
            const { transaction } = object;
            const { idTransaction, idActivity, activityName, creationDateTime, submitDateTimeAsString } = transaction;
            const { currency, quantity } = getQuantityAndCurrency(object);
            const titleText = this.getActivityTitle(idActivity, activityName);

            const content = (
                <div className="direct-debit-create-send-card__motivo-row">
                    <div className="direct-debit-create-send-card__creation-line">
                        <span className="direct-debit-create-send-card__label">
                            <I18n id="transactions.list.header.creationDate" />
                            {":\u0020"}
                        </span>
                        {creationDateTime ? <FormattedDate showTime withSpan date={creationDateTime} /> : null}
                    </div>
                    <div className="card__pending-transaction-data-description direct-debit-create-send-card__activity-line">
                        {titleText}
                    </div>
                </div>
            );

            return (
                <CardContainer key={idTransaction} className="confirmation__cards-container mt-0">
                    <Card
                        isDesktop={isDesktop}
                        className="confirmation__cards direct-debit-create-send-card"
                        icon={isDesktop && "images/transfer-PENDING.svg"}
                        iconClass="card__pending-transaction-icon"
                        hrClass="d-none"
                        title={
                            !isDesktop && (
                                <div>
                                    {submitDateTimeAsString && (
                                        <div className="confirmation-cards__title">
                                            <div className="confirmation-cards__title-data">
                                                <I18n id="forms.transaction.ticket.date" />
                                            </div>
                                            <div className="confirmation-cards__title-info">
                                                <span>{submitDateTimeAsString}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        }
                        content={isDesktop ? content : <div>{content}</div>}
                        rightContent={
                            <div className="confirmation-cards__right">
                                <div className="confirmation-cards__right-data">
                                    <FormattedAmount currency={currency} quantity={quantity} />
                                </div>
                            </div>
                        }
                    />
                </CardContainer>
            );
        });
    };

    render() {
        return this.dataRow();
    }
}

const mapStateToProps = (state) => ({
    multipleSignaturesData: transactionsSelectors.getMultipleSignaturesData(state),
});

export default connect(mapStateToProps)(withMultipleSignaturesContext(DirectDebitCreateSendDataTable));
